import { FC, memo } from 'react';
import { SText } from '@setvi/shared/components';
import { IProductEnhancerField } from '../../types';
import { OriginalCardContainer } from './styled';
import { ORIGINAL_FIELD_TO_COMPONENT } from './config';

interface OriginalFieldCardProps {
  field: IProductEnhancerField;
}

export const OriginalFieldCard: FC<OriginalFieldCardProps> = memo(
  ({ field }) => {
    const FieldComponent = ORIGINAL_FIELD_TO_COMPONENT[field.type];

    return (
      <OriginalCardContainer>
        <SText title={field.title} weight="semibold" size="sm" />

        <FieldComponent field={field} />
      </OriginalCardContainer>
    );
  }
);
